module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAdminRole) ? _c('div', {
    staticClass: "admin-view"
  }, [_c('permissions-header', {
    attrs: {
      "title": _vm.routeName
    }
  }), _vm._v(" "), _c('router-view')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-670dd565"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/permissions/AdminView.vue
// module id = 1917
// module chunks = 0